<template>
    <header id="exhibitPill" class="svgContainer" :class="[MutableIsActive ? 'is-active' : '']">
    <!-- <header id="exhibitPill" class="svgContainer is-active" > -->
        <div class="pillInteraction" ref="pillInteraction" @mouseenter="onEnter" @mousedown="onMouseDown" @mouseup="onMouseUp" @touchstart="onTouchStart" @touchend="onTouchEnd" :class="[MutableIsActive ? '' : 'is-small']"></div>
        <!-- <div class="pillInteraction" ref="pillInteraction" @mouseenter="onEnter" @mousedown="onMouseDown" @mouseup="onMouseUp" @touchstart="onTouchStart" @touchend="onTouchEnd"></div> -->
        <div class="appearence" :class="[MutableIsActive ? '' : 'is-small']">
        <!-- <div class="appearence"> -->
            <!-- <svg @mouseleave="onLeave" ref="svgPill" @touchend="onTouchEndOutside" class="svgPill" :class="[MutableIsActive ? '' : 'is-small', MutableIsPushed ? 'is-pushed' : '']" viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> -->
            <svg @mouseleave="onLeave" ref="svgPill" @touchend="onTouchEndOutside" class="svgPill is-pushed" viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g class="savior">
                    <g class="circleMenu">
                        <g transform="translate(15, 15)">
                            <path id="siteHeaderPath" fill="transparent" d="M100,50A50,50,0,1,1,50,0,50,50,0,0,1,100,50Z" />
                            <text>
                                <textPath href="#siteHeaderPath" xlink:href="#siteHeaderPath">
                                    <tspan><router-link :to="exhibitUrl" :xlink:href="'/'+exhibitUrl" :letter-spacing="'-0.5'">{{exhibitName.length > 40 ? exhibitName.substring(0,40)+'...' : exhibitName}}</router-link></tspan>
                                </textPath>
                            </text>
                        </g>
                    </g>
                </g>
                <g class="centerText">
                    <text x="66" y="70" text-anchor="middle" class="logo">{{centerText}}</text>
                    <!-- <text x="66" y="70" text-anchor="middle" class="logo"><router-link :to="exhibitUrl" :xlink:href="'/'+exhibitUrl">{{centerText}}</router-link></text> -->
                </g>
            </svg>
        </div>
    </header>
</template>

<script>

import EventBus from './../util/EventBus'
import * as types from './../store/mutation-types'

export default {
  name: 'exhibitPill',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    isPushed: {
        type: Boolean,
        default: false
    },
    centerText: {
        type: String,
        default: () => ''
    },
    exhibitName: {
        type: String,
        default: () => ''
    },
    exhibitUrl: {
        type: String,
        default: () => ''
    }
  },
  data () {
    return {
        MutableIsActive: JSON.parse(this.isActive),
        MutableIsPushed: JSON.parse(this.isPushed)
    }
  },
  mounted () {
    let exhibitPill = document.getElementById('exhibitPill');
      EventBus.$on('physics.ballB', coord => {
        exhibitPill.style.transform = 'translate(' + coord.x + 'px, ' + coord.y + 'px) rotate(' + coord.r + 'deg)'
      })
    //       this.$router.afterEach((to, from) => {
    //     if (this.MutableIsActive) {
    //         this.MutableIsActive = false
    //         EventBus.$emit('exhibitPill.leave')
    //     }
    // })
  },
  created () {
      if (this.$store.getters.getIsMobile) {
        document.addEventListener('touchstart', this.documentClick)
      } else {
        document.addEventListener('click', this.documentClick)
      }
  },
  destroyed () {
    // important to clean up!!
    if (this.$store.getters.getIsMobile) {
        document.removeEventListener('touchstart', this.documentClick)
    } else {
        document.removeEventListener('click', this.documentClick)
    }
  },
  methods: {
      onEnter () {
          if (!this.$store.getters.getIsMobile) {
            this.MutableIsActive = true
            this.$store.commit(types.UPDATE_PHYSICS, { field: 'exhibitPill', value: 'big' })
          }
      },
      onLeave () {
          if (!this.$store.getters.getIsMobile) {
            this.MutableIsActive = false
            this.$store.commit(types.UPDATE_PHYSICS, { field: 'exhibitPill', value: 'small' })
          }
      },
      onClick () {
        // if (this.$store.getters.getIsMobile) {
        //     if (this.MutableIsActive) {
        //         this.MutableIsActive = false
        //         this.$store.commit(types.UPDATE_PHYSICS, { field: 'exhibitPill', value: 'small' })
        //     } else {
        //         this.MutableIsActive = true
        //         this.$store.commit(types.UPDATE_PHYSICS, { field: 'exhibitPill', value: 'big' })
        //     }

        // } 
      },
      documentClick (e) {
        let el = this.$refs.svgPill
        let el2 = this.$refs.pillInteraction
        let target = e.target
        if ( el !== target && !el.contains(target) && el2 !== target && !el2.contains(target) )  {
            if (this.MutableIsActive) {
                this.MutableIsActive = false
                this.MutableIsPushed = false
                this.$store.commit(types.UPDATE_PHYSICS, { field: 'exhibitPill', value: 'small' })
            }
            // console.log('click on document')
        }
      },
      onTouchStart () {
          this.MutableIsPushed = true
            if (!this.MutableIsActive) {
                EventBus.$emit('exhibitPill.stop')
            }

      },
      onTouchEnd () {
          this.MutableIsPushed = true
            if (!this.MutableIsActive) {
                this.MutableIsActive = true
                this.$store.commit(types.UPDATE_PHYSICS, { field: 'exhibitPill', value: 'big' })
            } else if (this.MutableIsActive) {
                this.MutableIsActive = false
                this.$store.commit(types.UPDATE_PHYSICS, { field: 'exhibitPill', value: 'small' })
            }

      },
      onTouchEndOutside () {
        this.MutableIsPushed = false
        if (this.MutableIsActive) {
            this.MutableIsActive = false
            this.$store.commit(types.UPDATE_PHYSICS, { field: 'exhibitPill', value: 'small' })
        }
      },
      onMouseDown () {
          this.MutableIsPushed = true
      },
      onMouseUp () {
          this.MutableIsPushed = false
      }
  }
}
</script>

<style lang="scss" scoped>
    .svgContainer.is-active {
    	z-index: 1500;
    }
    .is-ie .svgContainer {
        display: none;
    }
</style>
